import { format } from "date-fns";

export type ProbateFieldJSON = {
  field_id: string | null;
  interface?: ProbateFieldInterfaceJSON;
  is_computed?: boolean;
  prerequisite_fields_ids?: string[];
};

export type ProbateFieldInterfaceJSON = {
  category?: string | null;
  answer_label?: string | null;
  answer_value?: string | null;
  question?: string | null;
  type?: string | null;
  options?: SelectOption[];
  learn_more_content?: string;
};

export type SelectOption = {
  id?: string;
  label?: string;
};

export const NO_ANSWER_YET = "- - -";

export class ProbateField {
  constructor(
    public id?: string,
    public interfaceType?: string,
    public question?: string,
    public learnMoreContent?: string,
    public category?: string,
    public answerLabel?: string,
    public answerValue?: string | number | boolean,
    public options?: SelectOption[],
    public isComputed?: boolean,
    public prerequisiteFieldIds?: string[]
  ) {}

  static fromJSON(json: ProbateFieldJSON): ProbateField {
    return new ProbateField(
      json?.field_id || undefined,
      json?.interface?.type || undefined,
      json?.interface?.question || undefined,
      json?.interface?.learn_more_content,
      json?.interface?.category || undefined,
      json?.interface?.answer_label || undefined,
      json?.interface?.answer_value !== null
        ? json?.interface?.answer_value
        : undefined,
      json?.interface?.options,
      json?.is_computed,
      json?.prerequisite_fields_ids
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  static fromStringified(object: any): ProbateField {
    return new ProbateField(
      object?.id || undefined,
      object?.interfaceType || undefined,
      object?.question || undefined,
      object?.learnMoreContent,
      object?.category || undefined,
      object?.answerLabel || undefined,
      object?.answerValue || undefined,
      object?.options,
      object?.isComputed,
      object?.prerequisiteFieldIds
    );
  }

  get answer(): string | undefined {
    switch (this?.interfaceType) {
      case "boolean":
        if (this?.answerValue === true) {
          return "Yes";
        } else if (this?.answerValue === false) {
          return "No";
        } else {
          return NO_ANSWER_YET;
        }
      case "date":
        if(!this?.answerValue || this.answerValue.toString() == "") {
          return NO_ANSWER_YET
        }
        return format(
          new Date(this?.answerValue?.toString() || ""),
          "MM/dd/yyyy"
        );
      case "number":
      case "number_negative":
      case "currency":
      case "currency_negative": {
        return (
          (this?.answerValue &&
            parseInt(this.answerValue.toString(), 10)?.toLocaleString()) ||
          NO_ANSWER_YET
        );
      }
      case "string":
      case "select":
        return this.getOptionLabel() || NO_ANSWER_YET;
      default:
        return this?.answerValue?.toString() || NO_ANSWER_YET;
    }
  }

  get prefix(): string {
    let prefix = "";
    switch (this?.interfaceType) {
      case "number_negative":
        prefix = "-";
        break;
      case "currency":
        prefix = "$";
        break;
      case "currency_negative":
        prefix = "-$";
        break;
    }
    return prefix;
  }

  static getBooleanValue(answer?: string | boolean | null): boolean {
    if (answer === "Yes") {
      return true;
    } else if (answer === "No") {
      return false;
    } else {
      return false;
    }
  }

  static getDollarValue(answer: string): number {
    return parseInt(answer.trim().replace(",", ""), 10);
  }

  getOptionLabel(): string | undefined {
    if (!this.answerValue) return undefined;
    const answerOption = this.options?.find(
      (option: SelectOption) => option.id === this.answerValue
    );
    return answerOption?.label;
  }

  // get value(): boolean | string | undefined {
  //   switch (this?.interfaceType) {
  //     case "boolean":
  //       if (this?.answerValue === "Yes") {
  //         return true;
  //       } else if (this?.answerValue === "No") {
  //         return false;
  //       } else {
  //         return NO_ANSWER_YET;
  //       }
  //     case "date":
  //     case "string":
  //     default:
  //       return this?.answerValue?.toString() || NO_ANSWER_YET;
  //   }
  // }
}
